<div class="bg-white relative"> <!-- lg:border-b lg:border-[#dfe0ff] dark:lg:border-secondary -->

  <button (click)="toggleTags()" class="z-20 text-gray-500 dark:text-white absolute top-6 right-6 lg:hidden">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>

  <!--
  <div [ngClass]="{'hidden': !tagsOpen, 'block': tagsOpen, 'transition': true, 'duration-500': true}" class="border-t border-gray-200 py-10" id="disclosure-1">
  -->
  <div [ngClass]="{'hidden': !tagsOpen, 'block': tagsOpen, 'transition': true, 'duration-500': true, 'mobile-scroll': true}" class="border-t border-gray-200 py-10" id="disclosure-1">

    <!-- Overlay when loading is true -->
    <div *ngIf="loading" class="absolute inset-0 bg-white bg-opacity-0 z-10"></div>

    <!-- Loading -->
    <div *ngIf="loading" class="absolute top-3 right-3">
      <svg class="animate-spin h-6 w-6 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <div class="mx-auto gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
      <div class="grid gap-y-10 grid-cols-2 md:grid-cols-6 md:gap-x-6">
        <!-- Filters content here -->

        <!-- Role Filter -->
        <fieldset>
          <legend class="block font-medium">Role</legend>
          <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
            <div *ngFor="let role of filterOptions.roles" class="flex items-center text-base sm:text-sm">
              <input [id]="'role-' + role.value" [name]="'roles[]'" [value]="role.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                     [checked]="isSelected('roles', role.value)"
                     (change)="onFilterChange('roles', role.value, $event)">
              <label [for]="'role-' + role.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ role.label }}</label>
            </div>
          </div>
        </fieldset>

        <!-- Deal Stage Filter -->
        <fieldset>
          <legend class="block font-medium">Deal Stage</legend>
          <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
            <div *ngFor="let stage of filterOptions.dealStages" class="flex items-center text-base sm:text-sm">
              <input [id]="'deal-stage-' + stage.value" [name]="'dealStages[]'" [value]="stage.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                     [checked]="isSelected('dealStages', stage.value)"
                     (change)="onFilterChange('dealStages', stage.value, $event)">
              <label [for]="'deal-stage-' + stage.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ stage.label }}</label>
            </div>
          </div>
        </fieldset>

        <!-- Deal Value Filter -->
        <fieldset>
          <legend class="block font-medium">Deal Value</legend>
          <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
            <div *ngFor="let value of filterOptions.dealValues" class="flex items-center text-base sm:text-sm">
              <input [id]="'deal-value-' + value.value" [name]="'dealValues[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                     [checked]="isSelected('dealValues', value.value)"
                     (change)="onFilterChange('dealValues', value.value, $event)">
              <label [for]="'deal-value-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
            </div>
          </div>
        </fieldset>

        <!-- Status Filter -->
        <fieldset>
          <legend class="block font-medium">Status</legend>
          <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
            <div *ngFor="let value of filterOptions.statuses" class="flex items-center text-base sm:text-sm">
              <input [id]="'status-' + value.value" [name]="'statuses[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                     [checked]="isSelected('statuses', value.value)"
                     (change)="onFilterChange('statuses', value.value, $event)">
              <label [for]="'status-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
            </div>
          </div>
        </fieldset>

        <!-- Close Dates -->
        <fieldset>
          <legend class="block font-medium">Close Dates</legend>
          <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
            <div *ngFor="let value of filterOptions.closeDates" class="flex items-center text-base sm:text-sm">
              <input [id]="'close-date-' + value.value" [name]="'closeDates[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                     [checked]="isSelected('closeDates', value.value)"
                     (change)="onFilterChange('closeDates', value.value, $event)">
              <label [for]="'close-date-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
            </div>
          </div>
        </fieldset>

        <div>

          <!-- My Judgement -->
          <fieldset class="mb-12">
            <legend class="block font-medium">My Judgement</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.myJudgement" class="flex items-center text-base sm:text-sm">
                <input [id]="'my-judgement-' + value.value" [name]="'myJudgement[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('myJudgement', value.value)"
                       (change)="onFilterChange('myJudgement', value.value, $event)">
                <label [for]="'my-judgement-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

          <!-- ICP Name -->
          <fieldset>
            <legend class="block font-medium">ICP Name</legend>
            <div class="space-y-6 pt-6 sm:space-y-4 sm:pt-4">
              <div *ngFor="let value of filterOptions.icpName" class="flex items-center text-base sm:text-sm">
                <input [id]="'icp-name-' + value.value" [name]="'icpName[]'" [value]="value.value" type="checkbox" class="h-4 w-4 flex-shrink-0 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                       [checked]="isSelected('icpName', value.value)"
                       (change)="onFilterChange('icpName', value.value, $event)">
                <label [for]="'icp-name-' + value.value" class="ml-3 min-w-0 flex-1 text-gray-600">{{ value.label }}</label>
              </div>
            </div>
          </fieldset>

        </div>

      </div>

    </div>
  </div>

</div>
